import * as zod from 'zod';

export const HaasNetworkConfig = zod.object({
  hostname: zod.string().nullable().default(null),
  port: zod.number().nullable().default(null),
});

export type HaasNetworkConfig = zod.infer<typeof HaasNetworkConfig>;
